export const CardPlacingOrder = ({
    children,
    className,
    stepTitle,
    changeStep,
    textButton,
    currentStep,
    isValid,
}) => {
    return (
        <div className={`CardPlacingOrder ${className} ${(currentStep && isValid) ? "CurrentStep" : ""}`}>
            <div className={'card-info'}>
                <h2>{stepTitle}</h2>
                {children}
            </div>
            <button disabled={!isValid} onClick={changeStep}>
                {textButton}
            </button>
        </div>
    )
}
